<template>
  <a-modal title="视频中心" :visible="visible" width="800px" @cancel="handleCancel" @ok="handleCancel" :footer="null">
    <div class="video-nav">
      <!-- 一级导航 -->
      <div class="primary-nav">
        <div
          v-for="(item, index) in navData"
          :key="index"
          :class="['nav-item', { active: currentPrimary === index }]"
          @click="currentPrimary = index"
        >
          {{ item.title }}
        </div>
      </div>

      <!-- 二级导航 -->
      <div class="secondary-nav">
        <template v-for="(subItem, subIndex) in navData[currentPrimary].children">
          <div :key="subIndex" class="sub-item" @click="openVideo(subItem.url)">
            {{ subItem.title }}
          </div>
        </template>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      currentPrimary: 0,
      navData: [
        {
          title: '初始化模块',
          children: [
            { title: '初始化录入模块', url: 'https://v.douyin.com/5f9ZS0qK8Dk/' },
            { title: '初始化员工管理', url: 'https://v.douyin.com/26PdBJf7NdA/' },
            { title: '初始化商品管理', url: 'https://v.douyin.com/r_GBIsDvvqA/' },
            { title: '初始化供应商&经销商', url: 'https://v.douyin.com/ZZG1thvdg0k/' },
            { title: '初始化--账户设置', url: 'https://v.douyin.com/gM67ADJXlCU/' },
            { title: '初始化--支付方式', url: 'https://v.douyin.com/gymzk4TzfDk/' },
            { title: '初始化-运营商业务', url: 'https://v.douyin.com/Wrcz9-Ao1Nk/' },
            { title: '初始化--历史记录导', url: 'https://v.douyin.com/3iaYVDK3a_U/' },
          ],
        },
        {
          title: '常用模块',
          children: [
            { title: '常用模块--财务管理', url: 'https://v.douyin.com/Nw-mrJZ39ro/' },
            { title: '常用模块--采购管理', url: 'https://v.douyin.com/5SWYgXhzDS4/' },
            { title: '常用模块--店面调库', url: 'https://v.douyin.com/NQrE-BNlZok/' },
            { title: '常用模块--柜组调库', url: 'https://v.douyin.com/kUyqNOs-Pvc/ ' },
            { title: '常用模块--库存管理', url: 'https://v.douyin.com/mpWbuuppRoY/' },
            { title: '常用模块--库存盘点', url: 'https://v.douyin.com/fyMBgKoS8oA/' },
            { title: '常用模块--统计报表', url: 'https://v.douyin.com/YwT6lXR0rdI/' },
            { title: '常用模块--系统设置', url: 'https://v.douyin.com/xcf8JdW14bs/' },
          ],
        },
        {
          title: '前台账务',
          children: [
            {
              title: '前台账务--批发业务',
              url: 'https://v.douyin.com/hQ3RTsNrlfA/',
            },
            {
              title: '前台账务--售后管理',
              url: 'https://v.douyin.com/ckNaPUSTfdA/',
            },
            {
              title: '前台账务--销售下单',
              url: 'https://v.douyin.com/GKMEwkvVmco/',
            },
          ],
        },
        {
          title: '特色模块',
          children: [
            { title: '特色模块--电子发票', url: 'https://v.douyin.com/7F-BX1z1yQE/' },
            { title: '特色模块--国家补贴', url: 'https://v.douyin.com/kzeGCLcLR3M/' },
            { title: '特色模块--会员管理', url: 'https://v.douyin.com/tHcaKuEP4qY/' },
            { title: '特色模块--利润总览', url: 'https://v.douyin.com/Azz1srcCSBc/' },
            { title: '特色模块--系统收银', url: 'https://v.douyin.com/PRy3fla3iYs/' },
            { title: '特色模块--运营商业务', url: 'https://v.douyin.com/f7o5D-0maPA/' },
            { title: '特色模块--终端直降', url: 'https://v.douyin.com/XOdu0z5lofQ/' },
            { title: '特色模块--无串码入库', url: 'https://v.douyin.com/Vo1Ymb7iS-U/' },
          ],
        },
        {
          title: ' 会员权益',
          children: [{ title: ' 会员权益', url: 'https://v.douyin.com/QMAq6Fp0A0Q/ ' }],
        },
      ],
    }
  },

  methods: {
    openVideo(url) {
      window.open(url, '_blank')
    },
    handleCancel() {
      this.visible = false
    },
    showModal() {
      this.visible = true
    },
  },
}
</script>

<style scoped>
.video-nav {
  display: flex;
  height: 400px;
}

.primary-nav {
  width: 200px;
  border-right: 1px solid #e8e8e8;
}

.nav-item {
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.3s;
}

.nav-item:hover {
  background: #f5f5f5;
}

.nav-item.active {
  background: #e6f7ff;
  border-right: 3px solid #1890ff;
}

.secondary-nav {
  flex: 1;
  padding: 0 16px;
  overflow-y: auto;
}

.sub-item {
  padding: 8px 12px;
  margin: 4px 0;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s;
}

.sub-item:hover {
  background: #f5f5f5;
  color: #1890ff;
}
</style>
